<template>
  <section class="rows">
    <div class="center-container">
      <div class="container">
        <div class="content reporting-row">
          <div class=" container form-group col-lg-5">
            <label>Villes</label>
            <select v-on:change="changedSelect()"
                    v-model="selectedVille"
                    class="form-control demande-filters"
                    id="ville"
            >
              <option value="0">Sélectionner une ville</option>
              <option
                v-for="ville in villes.availableVilles"
                v-bind:value="ville"
                v-bind:item="selectedVille"
                v-bind:key="ville.id"
              >
                {{ ville.nom }}
              </option>
            </select>
          </div>
          <div class=" container form-group col-lg-2">
            <label>Années</label>
            <select v-on:change="changedSelect()"
                    v-model="selectedYear"
                    class="form-control demande-filters"
                    id="annee"
            >
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
              <option value="2027">2027</option>
              <option value="2028">2028</option>
              <option value="2029">2029</option>
              <option value="2030">2030</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="height-container">
      <div class="container">
        <div>
          <canvas id="myChart"></canvas>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Chart from 'chart.js';

const labels = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre'
];

export default {
  computed: {
    ...mapState(['villes'])
  },
  data() {
    return {
      selectedVille: '0',
      selectedYear: '2022',
      myChart: null,
      config: {
        type: 'bar',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'Tournées',
              backgroundColor: 'rgb(35, 191, 170)',
              borderColor: 'rgb(35, 191, 170)',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              label: 'Demandes',
              backgroundColor: 'rgb(222, 41, 16)',
              borderColor: 'rgb(222, 41, 16)',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
            {
              label: 'Signalements',
              backgroundColor: 'rgb(58, 57, 107)',
              borderColor: 'rgb(58, 57, 107)',
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            },
          ],
        },
        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  if (Number.isInteger(value)) {
                    return value;
                  }
                }
              }
            }]
          }
        },
      },
    };
  },
  mounted() {
    this.$store.dispatch('fetchAllVilles');
  },
  methods: {
    async changedSelect() {
      await this.$store.dispatch('getStatistiques', {
        id_ville: this.selectedVille.id,
        year: this.selectedYear
      });
      this.config.data.datasets[0].data = this.$store.state.statistiques.dataTournees;
      this.config.data.datasets[1].data = this.$store.state.statistiques.dataDemandes;
      this.config.data.datasets[2].data = this.$store.state.statistiques.dataSignalements;

      if (this.myChart) {
        this.myChart.destroy();
      }

      const chartElement = document.getElementById('myChart');
      if (chartElement) {
        this.myChart = new Chart(chartElement, this.config);
        this.myChart.update();
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../scss/variables';

.row.reporting-row {
  align-items: start;
}

.content {
  min-height: 120px
}

button.save-btn {
  background-color: $suez-blue;
  background-repeat: no-repeat;
  background-position: 15px center;
  color: white;
  font-size: 14px;
  font-weight: bold;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: none;
  padding: 7px 15px 8px 20px;
}

.big-checkbox {
  width: 20px;
  height: 20px;
}

.center-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 30%;
}

.height-container {
  margin-top: 8%;
}
</style>



// WEBPACK FOOTER //
// Statistiques.vue?e53b89b6